<template>
<form
  method="post"
  @submit.prevent="search">
  <nav id="subnavtop"
    class="navbar is-subnavtop is-shadowed">
    <div
      @click="flide()"
      class="burger is-pulled-right"
      ref="menubutton">
      <span class="upper"></span>
      <span class="middle"></span>
      <span class="bottom"></span>
    </div>
    <div class="navbar-menu">
      <a class="nav-item nav-brand no-text"
        href="/">
        <span class="logo-wrapper">
          <img :src="`${assets}/img/logo_getcloser_25_11_18_3.svg`">
        </span>
      </a>
      <div class="navbar-item is-expanded is-paddingless is-hidden-touch"></div>
      <router-link
        id="accountLink"
        class="is-hidden-touch navbar-item is-tab"
        :to="{ name: 'accountEdit'}" active-class="is-active">
        Hi, {{user.nickname}}
      </router-link>
      <a
        id="logoutLink"
        class="is-hidden-touch navbar-item is-tab"
        @click.prevent="doLogout">
      Log out</a>
    </div>
  </nav>
</form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: ['name', 'params', 'disabled'],

  created() {
    this.$eventBus.$on('logout', options => {
      this.doLogout(options)
    })
  },
  mounted() {
    this.$root.$on('sidebarclose', this.toggleMenuButton)
  },
  computed: {
    assets() {
      return process.env.assets || '/static'
    },
    ...mapState(['user'])
  },
  methods: {
    toggleMenuButton() {
      this.$refs.menubutton.classList.toggle('active')
    },
    flide() {
      this.$root.$emit('flide')
      this.toggleMenuButton()
    },

    async doLogout(options) {
      const data = await this.apiGet('logout', null, false)
      if (data) {
        this.logout()
        if (!options || !options.localStorageSignal) {
          window.localStorage.setItem('logoutTime', `${Date.now()}`)
        }
        window.location.href = '/'
      }
    },
    ...mapActions(['logout'])
  },
  beforeDestroy() {
    this.$root.$off('sidebarclose', this.toggleMenuButton)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/searchbar.vue